import type { NextPage } from 'next';
import { CookieDisclaimerComponent } from 'ui';

const CookieDisclaimer: NextPage = () => {
	return <CookieDisclaimerComponent name="Descatalogados" />;
};

export default CookieDisclaimer;
